// extracted by mini-css-extract-plugin
export default {"departments":"PG-z","departmentHeading":"QG-z","departmentSection":"RG-z","departmentName":"SG-z","departmentLink":"TG-z","expandIcon":"UG-z"};